/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-01-29T17:52:53.308Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'Milf'

export default NICHE
